export const PAYOUT_STATUS_META = {
  PENDING_APPROVAL: { color: '#BA7517', bg: '#FDF6E3', icon: 'clock_fill' },
  APPROVED:          { color: '#0C447C', bg: '#EBF0FC', icon: 'paperplane_fill' },
  REJECTED:          { color: '#A32D2D', bg: '#FCEBEB', icon: 'xmark_circle_fill' },
  PAID:              { color: '#27500A', bg: '#EAF3DE', icon: 'checkmark_seal_fill' },
  FAILED:            { color: '#A32D2D', bg: '#FCEBEB', icon: 'xmark_circle_fill' },
  CANCELLED:         { color: '#5F5E5A', bg: '#F1EFE8', icon: 'xmark' },
}

export const APPROVAL_DECISION_META = {
  PENDING:  { color: '#8e8e93', icon: 'clock_fill' },
  APPROVED: { color: '#1a6b42', icon: 'checkmark_circle_fill' },
  REJECTED: { color: '#a32d2d', icon: 'xmark_circle_fill' },
}

export function statusMeta(code) {
  return PAYOUT_STATUS_META[code] ?? { color: '#5F5E5A', bg: '#F1EFE8', icon: 'question_circle_fill' }
}

export function decisionMeta(code) {
  return APPROVAL_DECISION_META[code] ?? { color: '#8e8e93', icon: 'question_circle_fill' }
}
